/**
 * Created by Carsten Hibbeler on 08.02.2016.
 */
'use strict';

import L from 'external/leaflet';

const southWest = L.latLng(47.2703, 5.8667),
    northEast = L.latLng(55.0585, 15.0419),
    defaultBounds = L.latLngBounds(southWest, northEast),
    defaultOptions = { animate: false };

export default class DefaultPosition {

    constructor(props) {
        this.boundRequestHandled = false;
        this.boundRequestCb = this.boundRequestCb.bind(this);
    }

    initOptions(o) {
        o.boundRequest = {
            bounds: defaultBounds,
            options: defaultOptions,
            cb: this.boundRequestCb
        };
        return o;
    }

    boundRequestCb() {
        this.boundRequestHandled = true;
    }
}

DefaultPosition.staticPlugin= true;





// WEBPACK FOOTER //
// ./js/plugins/DefaultPosition.js